<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Payment Terms</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6">
            <v-btn color="primary" small to="/new-payment-terms">
              <v-icon left dark>mdi-plus</v-icon>New Payment Terms
            </v-btn>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6"> </v-col>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="termsData"
              :search="search"
              :mobile-breakpoint="zeroValue"
            >
              <!-- name template -->
              <template v-slot:item.Name="{ item }">
                <v-btn color="primary" text :to="`/payment-terms/${item.id}`">
                  {{ item.Name }}
                  <v-icon right>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn
                  color="editIcon"
                  text
                  :to="`/payment-terms/${item.id}`"
                  icon
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    customersDialog: false,
    loader: false,
    zeroValue: 0,
    pageItems: 100,
    date: null,
    headers: [
      { text: "Title", value: "name" },
      { text: "Days", value: "days" },
      { text: "Action", value: "action" },
    ],
    termsData: [],
    excelFile: null,
  }),
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    getData() {
      const self = this;
      this.$store
        .dispatch("get", `/payment-terms`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.termsData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>